<template>
    <div class="collapsible">
        <b-button
            variant="link"
            class="collapsible__button"
            :class="visible ? null : 'collapsed'"
            @click="toggleVisibility">
            <Icon
                class="collapsible__icon collapsible__icon--opened"
                :type="'chevron-up-bold'"
                :width="14"
                :height="9" />
            <Icon
                class="collapsible__icon collapsible__icon--closed"
                :type="'chevron-down-bold'"
                :width="14"
                :height="9" />
            <span class="collapsible__title">{{ title }}</span>
        </b-button>
        <b-collapse
            v-model="visible"
            class="collapsible__body">
            <b-card>
                <slot />
            </b-card>
        </b-collapse>
    </div>
</template>

<script>
export default {
    name: 'Collapsible',
    props: {
        title: { type: String, required: true },
        showOnInit: { type: Boolean, default: false },
    },
    data () {
        return {
            visible: false,
        };
    },
    mounted () {
        if (this.showOnInit) {
            this.visible = true;
        }
    },
    methods: {
        toggleVisibility () {
            this.visible = !this.visible;
            this.$emit('update', this.visible);
        },
    },
};
</script>

<style scoped lang="scss">
.collapsible {
  .collapsed > &__icon--opened,
  :not(.collapsed) > &__icon--closed {
    display: none;
  }

  .card {
    background-color: inherit;
    border-width: 0;
    color: $mb-grey5;
  }

  .card-body {
    padding-left: 0;
  }

  .btn-link,
  .btn-link:focus,
  .btn-link.focus,
  .btn-link:hover {
    font-weight: 400;
    color: $mb-grey5;
    text-decoration: none;
    background: none;
  }
}

.collapsible__title {
  @include font-migrosbank();
}

.collapsible__button {
  align-items: center;
  padding: 0;
  margin-top: 12px;
}
</style>
